import type { IImage } from '@/services/models/Media/Image';

/**
 * AR and VTO button icons from Artlabs config.
 */
export interface IArtlabsConfigImages {
  /**
   * The AR icon.
   */
  ar: IImage;
  /**
   * The VTO icon.
   */
  vto: IImage;
}

/**
 * Builds {@link IArtlabsConfigImages} from `artlabs` config URL strings (`arIcon`, `vtoIcon`).
 * @param arIcon - The URL of the AR icon.
 * @param vtoIcon - The URL of the VTO icon.
 * @returns The {@link IArtlabsConfigImages} object.
 */
export function getArtlabsConfigImages(
  arIcon: string,
  vtoIcon: string
): IArtlabsConfigImages {
  return {
    ar: {
      uuid: 'artlabs-ar-icon',
      src: arIcon,
      alt: 'AR icon',
      width: 25,
      height: 40
    },
    vto: {
      uuid: 'artlabs-vto-icon',
      src: vtoIcon,
      alt: 'VTO icon',
      width: 40,
      height: 40
    }
  };
}
